// Player commands: what the view asks the simulation to do. Queued as the tap
// lands and drained at the top of the next fixed step (00-architecture.md §2,
// slot 1), so input never mutates sim state at an arbitrary point in the frame.
//
// Plain data: the picking that produces these lives in `render/picking.ts`,
// because only the view knows about cameras and canvases.

// Type-only imports: erased at build time, so no cycle exists at runtime.
import type { Cell } from "./blocks";
import type { BugId } from "./bugs";
import type { PowerUpId } from "./powerups";

export type Command =
  | { readonly kind: "tapBug"; readonly id: BugId }
  | { readonly kind: "repairBlock"; readonly cell: Cell }
  | { readonly kind: "tapPowerUp"; readonly id: PowerUpId };

export class CommandQueue {
  private queue: Command[] = [];

  push(command: Command): void {
    this.queue.push(command);
  }

  /** Take everything queued so far, leaving the queue empty. */
  drain(): readonly Command[] {
    const taken = this.queue;
    this.queue = [];
    return taken;
  }
}
